import { polygonToCells } from "h3-js";

import type { ResolutionType, ViewportType } from "~/lib/map/types";
import { getBoundsFromViewport } from "./getBoundsFromViewport";

export const getH3IndexesFromViewport = (viewport: ViewportType, resolution: ResolutionType) => {
  const { north, south, east, west } = getBoundsFromViewport(viewport);

  return polygonToCells(
    [
      [north, west],
      [north, east],
      [south, east],
      [south, west],
    ],
    resolution,
  );
};
